import React from 'react';
import { buildUseStyles, useTheme } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import PropTypes from 'prop-types';
import {
  paddingConverter,
  paddingDefaultProps,
  paddingPropTypes,
} from 'Components/ComponentLibrary/DesignSystem/padding';
import useMobileLayout from 'Hooks/useMobileLayout';
import useUserContext from 'Context/UserContext';
import { useLayoutContext } from 'Context/LayoutContext';

const useStyles = buildUseStyles('NewVerticalStack', () => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    minWidth: '0',
  },
}));

const NewVerticalStack = (props) => {
  const {
    height,
    children,
    dataTestAttributes,
    overflow,
    spacing,
    flex,
  } = props;
  const classes = useStyles();
  const { isAgent } = useUserContext();
  const isMobile = useMobileLayout();

  const theme = useTheme();

  // TODO: replace all of this with FC's FullViewport (see PA-15895)
  const { hideBottomNavigation, isNavigationVisible } = useLayoutContext();
  let verticalSpaceLost = 0;
  if (isAgent) {
    verticalSpaceLost = theme.heights.advisorNavigationHeight;
  } else if (isMobile) {
    verticalSpaceLost = !hideBottomNavigation && isNavigationVisible ? theme.heights.mobileBottomNavigationHeight : 0;
  } else if (isNavigationVisible) {
    verticalSpaceLost = theme.heights.desktopTopNavigationHeight;
  }
  const heightProps = { height: '100%' };
  if (height === 'screen') {
    heightProps.height = `calc(100vh - ${verticalSpaceLost}px)`;
  } else if (height === 'open') {
    heightProps.minHeight = `calc(100vh - ${verticalSpaceLost}px)`;
  }

  return (
    <Box
      className={classes.root}
      {...heightProps}
      {...dataTestAttributes}
      style={{
        overflow,
        padding: paddingConverter(theme, props),
        gap: `${theme.spacing(spacing)}px`,
        flex,
      }}
    >
      {children}
    </Box>
  );
};

NewVerticalStack.defaultProps = {
  ...paddingDefaultProps,
  height: 'default',
  spacing: 0,
  padding: null,
  dataTestAttributes: {},
  overflow: 'visible',
};

NewVerticalStack.propTypes = {
  ...paddingPropTypes,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]).isRequired,
  height: PropTypes.oneOf(['open', 'screen', 'default']),
  overflow: PropTypes.oneOf(['visible', 'auto']),
  spacing: PropTypes.number,
  dataTestAttributes: PropTypes.object,
  flex: PropTypes.number,
};

export default NewVerticalStack;
